import { useLocalSearchParams } from 'expo-router';

import {
  ExpoRouterDemoBackButton,
  ExpoRouterDemoScreen,
  ExpoRouterDemoTitle,
} from '../../../../../../components';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  const { addressId, productSlug, lineItemId } = useLocalSearchParams<{
    addressId: string;
    productSlug: string;
    lineItemId: string;
  }>();

  return (
    <ExpoRouterDemoScreen>
      <ExpoRouterDemoTitle>
        Edit Delivery Customization — {addressId}/{productSlug}/{lineItemId}
      </ExpoRouterDemoTitle>
      <ExpoRouterDemoBackButton
        href={`/(modals)/delivery/${addressId}/${productSlug}` as never}
        dismiss
      />
    </ExpoRouterDemoScreen>
  );
}
